import { Scalars } from "@octokit/graphql-schema";
import { Maybe } from "graphql/jsutils/Maybe";
import { UpdateMethodInput } from "../../graphql/generated/schema-types";

export class MethodInputStub implements UpdateMethodInput {
  documentationUrl: Maybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  methodName: Maybe<Scalars["String"]>;
}
